/**
 * resetAll — сбросить всё persistent state до состояния «впервые открыл апку».
 *
 * JB 2026-05-25 admin-tool: «мне как админу нужна в дебаге кнопка чтобы я
 * мог свое состояние сбросить так как будто в самый первый раз открываю
 * апку».
 *
 * Что сбрасывается:
 *   1. **Game state** (persist 2026-05-25) → wipe localStorage,
 *      на reload создастся initial state
 *   2. **Artifacts** (persist) → пустой unlocked Set, очищается revealQueue,
 *      localStorage key 'sai-artifacts-v1' удаляется
 *   3. **Onboarding** (persist) → пустой dismissed Set, key 'sai-onboarding-v1'
 *   4. **Atlas rewards** (persist) → ключ 'sai-atlas-rewards-v1'
 *   5. **Funnel firsts** (persist) → key 'sai-funnel-firsts-v1' — чтобы
 *      milestones типа `first_tap` снова эмитились
 *   6. **Return visit** (persist) → ключ 'sai-return-visit-v1' — чтобы
 *      lastVisitAt сбросился, return greeting снова покажется после паузы
 *   7. **Profile soft-ask** (persist) → ключ 'sai-profile-ask-v1'
 *   8. **Consent** (persist) → ключ 'sai-consent-v1' — пользователь
 *      снова увидит ConsentBanner
 *   9. **Settings** (persist) НЕ сбрасываются — пользователь может
 *      специально настроил mute/volume и не хочет это терять
 *
 * После сброса страница перезагружается через `location.reload()` — это
 * гарантирует что все hooks / effects / Howler-loops инициализируются
 * заново с нуля. Иначе можно получить полу-сброшенное состояние с
 * висящими timers.
 */

const PERSISTED_KEYS_TO_WIPE: readonly string[] = [
  'sai-game-state-v1',
  'sai-artifacts-v1',
  'sai-onboarding-v1',
  'sai-atlas-rewards-v1',
  'sai-funnel-firsts-v1',
  'sai-return-visit-v1',
  'sai-profile-ask-v1',
  'sai-consent-v1',
  'sai-tg-id-v1', // TG WebApp verified identity (Этап 4 backend)
];

export function resetAllStateAndReload(): void {
  for (const key of PERSISTED_KEYS_TO_WIPE) {
    try {
      window.localStorage.removeItem(key);
    } catch {
      // Storage may be unavailable in some sandboxed contexts — silent ignore.
    }
  }
  // Reload — все Zustand stores инициализируются с дефолтами (game state
  // не persisted), persist-stores увидят пустой localStorage.
  window.location.reload();
}
